import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import ConfigAPI from '@/config/api'
import Session from '@/handler/session'

Vue.use(VueAxios, axios)

const instance = axios.create();

const servicesAPI = {
  showEmail(data) {
    var url = ConfigAPI.baseURL + "notifications/email/" + data.id + Session.getToken();
    return instance.get(url);
  },
  saveEmail(data) {
    var params = data
    var url = ConfigAPI.baseURL + "notifications/email/" + data.id + Session.getToken();
    return instance.post(url,params);
  },
  testEmail(data) {
    var params = data
    var url = ConfigAPI.baseURL + "notifications/email/" + data.id + '/test' + Session.getToken();
    return instance.post(url,params);
  },

  showSMS(data) {
    var url = ConfigAPI.baseURL + "notifications/sms/" + data.id + Session.getToken();
    return instance.get(url);
  },
  saveSMS(data) {
    var params = data
    var url = ConfigAPI.baseURL + "notifications/sms/" + data.id + Session.getToken();
    return instance.post(url,params);
  },
  testSMS(data) {
    var params = data
    var url = ConfigAPI.baseURL + "notifications/sms/" + data.id + '/test' + Session.getToken();
    return instance.post(url,params);
  },

  obtenerWhatsapp() {
    var url = ConfigAPI.baseURL + "notifications/whatsapp" + Session.getToken();
    return instance.get(url);
  },
  mostrarWhatsapp(id) {
    var url = ConfigAPI.baseURL + "notifications/whatsapp/" + id + Session.getToken();
    return instance.get(url);
  },
  agregarWhatsapp(data) {    
      var params = data
      var url = ConfigAPI.baseURL + "notifications/whatsapp" + Session.getToken();
      return instance.post(url,params);
  },
  editarWhatsapp(data) {    
      var params = data    
      var url = ConfigAPI.baseURL + "notifications/whatsapp/"+ data.id + Session.getToken();
      return instance.post(url,params);
  },
  eliminarWhatsapp(id) {
    var url = ConfigAPI.baseURL + "notifications/whatsapp/"+ id + Session.getToken();
    return instance.delete(url);
  },
  showWhatsapp(data) {
    var url = ConfigAPI.baseURL + "notifications/whatsapp/" + data.id + Session.getToken();
    return instance.get(url);
  },
  saveWhatsapp(data) {
    var params = data
    var url = ConfigAPI.baseURL + "notifications/whatsapp/" + data.id + Session.getToken();
    return instance.post(url,params);
  },
  testWhatsapp(data) {
    var params = data
    var url = ConfigAPI.baseURL + "notifications/whatsapp/" + data.id + '/test' + Session.getToken();
    return instance.post(url,params);
  },

  listWhatsappTemplates() {
    var url = ConfigAPI.baseURL + "notifications/whatsapp/templates" + Session.getToken();
    return instance.get(url);
  },
  validateWhatsappTemplate(templateId, notificationsWhatsappId) {
    var params = { notifications_whatsapp_id: notificationsWhatsappId }
    var url = ConfigAPI.baseURL + "notifications/whatsapp/templates/" + templateId + "/validate" + Session.getToken();
    return instance.post(url,params);
  },
  refreshWhatsappTemplateStatus(templateId) {
    var url = ConfigAPI.baseURL + "notifications/whatsapp/templates/" + templateId + "/refresh" + Session.getToken();
    return instance.post(url);
  },
  
  showPush(data) {
    var url = ConfigAPI.baseURL + "notifications/push/" + data.id + Session.getToken();
    return instance.get(url);
  },
  savePush(data) {
    var params = data
    var url = ConfigAPI.baseURL + "notifications/push/" + data.id + Session.getToken();
    return instance.post(url,params);
  },
  testPush(data) {
    var params = data
    var url = ConfigAPI.baseURL + "notifications/push/" + data.id + '/test' + Session.getToken();
    return instance.post(url,params);
  },
  regeneratePush(data) {
    var params = data
    var url = ConfigAPI.baseURL + "notifications/push/" + data.id + '/regenerate' + Session.getToken();
    return instance.post(url,params);
  },

  manualSend(data) {
    var params = data
    var url = ConfigAPI.baseURL + "notifications/manual-send" + Session.getToken();
    return instance.post(url,params);
  },

  manualSendInternal(data) {
    var params = data
    var url = ConfigAPI.baseURL + "notifications/internal/manual-send" + Session.getToken();
    return instance.post(url,params);
  },

  listInternal(data) {
    var params = data
    var url = ConfigAPI.baseURL + "notifications/internal/list" + Session.getToken();
    return instance.post(url,params);
  },
  markAllInternalRead() {
    var url = ConfigAPI.baseURL + "notifications/internal/read-all" + Session.getToken();
    return instance.post(url);
  },
  markInternalRead(id) {
    var url = ConfigAPI.baseURL + "notifications/internal/" + id + "/read" + Session.getToken();
    return instance.post(url);
  },
  archiveInternal(id) {
    var url = ConfigAPI.baseURL + "notifications/internal/" + id + "/archive" + Session.getToken();
    return instance.post(url);
  },
  restoreInternal(id) {
    var url = ConfigAPI.baseURL + "notifications/internal/" + id + "/restore" + Session.getToken();
    return instance.post(url);
  },
  archiveAllInternal() {
    var url = ConfigAPI.baseURL + "notifications/internal/archive-all" + Session.getToken();
    return instance.post(url);
  },

  obtenerStaff() {
    var url = ConfigAPI.baseURL + "staff" + Session.getToken();
    return instance.get(url);
  },
  obtenerRoles() {
    var url = ConfigAPI.baseURL + "roles" + Session.getToken();
    return instance.get(url);
  },

  listEventTypes() {
    var url = ConfigAPI.baseURL + "notifications/event-types" + Session.getToken();
    return instance.get(url);
  },
  updateEventTypeRecipients(id, data) {
    var params = data
    var url = ConfigAPI.baseURL + "notifications/event-types/" + id + Session.getToken();
    return instance.post(url, params);
  },
  sendEventTypeTest(id) {
    var url = ConfigAPI.baseURL + "notifications/event-types/" + id + "/test" + Session.getToken();
    return instance.post(url);
  },

  listNotificationsLog(data) {
    var params = data
    var url = ConfigAPI.baseURL + "notifications/log/list" + Session.getToken();
    return instance.post(url, params);
  }

}

export default servicesAPI;
